import { useQueries } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Fetches invoices for multiple patients in parallel.
 * This fires one request per patient (N+1), which is fine for now since members
 * typically have few pets. We can add server-side batching or caching if needed.
 */
export function useListPatientInvoices(patientIds: string[]) {
  const api = useOsApi()

  const queries = useQueries({
    queries: patientIds.map((patientId) => ({
      queryKey: ['patient', patientId, 'invoices'],
      queryFn: async () => {
        const response = await api.get('/patients/:patientId/invoices', {
          params: { patientId },
        })
        if (!response.success) throw new Error(response.error.message)
        return response.data.invoices
      },
      staleTime: 60_000,
    })),
  })

  const isLoading = queries.some((q) => q.isLoading)
  const invoices = queries.flatMap((q, i) =>
    q.data ? [{ patientId: patientIds[i], invoices: q.data }] : []
  )

  return { invoices, isLoading }
}
